import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';

import SearchForm from '../components/searchForm';
import axios from '../axios';


class SearchFormPage extends Component {
    state = {
        results: [],
        redirect: false
    };

    componentDidMount() {
        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/admin/checkadmin`, {headers: {"Authorization": token}})
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    };

    editChangeHandler = event => {
        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/ref_values/searchcode?code=${event.target.value}`, {headers: {"Authorization": token}})
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        results: data.searchCode.results.slice(0, 5),
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }

                console.log(this.state.results)
            })
            .catch(err => {
                console.log(err)
            })
    };


    render() {
        if (this.state.redirect) {
            return <Redirect to="/"/>
        }

        return (
            <SearchForm
                editChange={this.editChangeHandler}
                suggestions={this.state.results}
            />
        )
    }
}

export default SearchFormPage;


// WEBPACK FOOTER //
// ./src/containers/SearchForm.js